/**
 * ENFAMI Footer — cookie bar + mesure hauteur pour stacking widgets
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'nm_cookie_consent';

  function lsGet(k) {
    try { return localStorage.getItem(k); } catch (e) { return null; }
  }

  function lsSet(k, v) {
    try { localStorage.setItem(k, v); } catch (e) {}
  }

  function syncCookieHeight() {
    var bar = document.getElementById('nm-cookie');
    var h = 0;
    if (bar && !bar.hidden && document.body.classList.contains('nm-cb-on')) {
      h = Math.ceil(bar.getBoundingClientRect().height) || 0;
    }
    document.documentElement.style.setProperty('--ef-cookie-h', h + 'px');
  }

  function syncStickyAtcHeight() {
    var sticky = document.querySelector('sticky-add-to-cart');
    var bar = sticky && sticky.querySelector('.sticky-add-to-cart__bar');
    var h = 0;
    if (bar) {
      var style = window.getComputedStyle(bar);
      var visible = style.display !== 'none' && style.visibility !== 'hidden' && bar.offsetHeight > 0;
      if (visible) h = Math.ceil(bar.getBoundingClientRect().height) || 0;
    }
    document.documentElement.style.setProperty('--ef-sticky-atc-h', h + 'px');
  }

  function syncFloatStack() {
    syncCookieHeight();
    syncStickyAtcHeight();
  }

  function initCookie() {
    var bar = document.getElementById('nm-cookie');
    if (!bar) return;
    if (lsGet(STORAGE_KEY)) {
      syncFloatStack();
      return;
    }

    bar.hidden = false;
    document.body.classList.add('nm-cb-on');
    syncFloatStack();

    var accept = document.getElementById('nm-cookie-accept');
    var refuse = document.getElementById('nm-cookie-refuse');

    function closeBar(value) {
      lsSet(STORAGE_KEY, value);
      bar.hidden = true;
      document.body.classList.remove('nm-cb-on');
      syncFloatStack();
    }

    if (accept) accept.addEventListener('click', function () { closeBar('all'); });
    if (refuse) refuse.addEventListener('click', function () { closeBar('none'); });

    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(syncCookieHeight);
      ro.observe(bar);
    }
  }

  function initStickyWatch() {
    var sticky = document.querySelector('sticky-add-to-cart');
    if (!sticky) return;
    if (typeof ResizeObserver !== 'undefined') {
      var ro = new ResizeObserver(syncStickyAtcHeight);
      ro.observe(sticky);
      var bar = sticky.querySelector('.sticky-add-to-cart__bar');
      if (bar) ro.observe(bar);
    }
    window.addEventListener('scroll', syncStickyAtcHeight, { passive: true });
  }

  function boot() {
    initCookie();
    initStickyWatch();
    syncFloatStack();
    window.addEventListener('resize', syncFloatStack, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
